import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { CourseStructureCategory } from './course-structure-category.model';

export class CourseStructureCategoryStateModel extends EntityStateModel<CourseStructureCategory> {}
